import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/ui";
import { CHAPTERS, STATS, CONTACT, EKTIREN, waLink, IMAGES } from "@/data/site";
import ektirenLogo from "@/assets/brand/ektiren-logo.png";

export default function Hakkimizda() {
  return (
    <div className="pt-4">
      {/* Hero */}
      <section className="relative py-20 sm:py-28 overflow-hidden grain">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-neon-magenta/20 blur-[130px] rounded-full" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <Eyebrow>Hakkımızda</Eyebrow>
          <h1 className="mt-6 font-display font-extrabold text-5xl sm:text-7xl leading-[0.95]">
            <MaskedLines lines={["Ege'nin dijital", "nabzı burada"]} lineClassName="[&:nth-child(2)]:text-gradient" />
          </h1>
          <Reveal delay={0.5}>
            <p className="mt-7 max-w-2xl text-lg text-slate-300 leading-relaxed">
              İzmir Medya; sosyal medya yönetimi, prodüksiyon ve dijital çözümleri tek çatı altında toplayan yaratıcı bir ajanstır. Markaların dijitalde fark yaratması için stratejiyle sanatı birleştiriyoruz.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Chapters */}
      <section className="py-16 sm:py-24 bg-ink-900/50 border-y border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-16">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.05}>
              <div className="grid lg:grid-cols-12 gap-6 items-start border-b border-white/10 pb-16 last:border-0">
                <div className="lg:col-span-2 font-display text-6xl font-extrabold text-transparent [-webkit-text-stroke:2px_#D946EF]">{c.no}</div>
                <h2 className="lg:col-span-4 font-display text-3xl sm:text-4xl font-bold">{c.title}</h2>
                <p className="lg:col-span-6 text-lg text-slate-300 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <Eyebrow>Stüdyomuz &amp; Teknoloji</Eyebrow>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold">Profesyonel ekipman,<br /><span className="text-gradient">tutkulu ekip.</span></h2>
            <p className="mt-5 text-slate-300 text-lg">4K sinema kameraları, FPV drone'lar, profesyonel ışık ve ses ekipmanları. Fikirden yayına kadar her aşamada yanınızdayız.</p>
            <div className="mt-10 grid grid-cols-2 gap-8">
              {STATS.map((s) => (
                <div key={s.label}>
                  <div className="font-display text-4xl font-extrabold text-gradient">{s.value}</div>
                  <div className="text-sm text-slate-400 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15} className="grid grid-cols-2 gap-4">
            <img src={IMAGES.editing} alt="Kurgu" className="rounded-2xl aspect-square object-cover neon-border" />
            <img src={IMAGES.camera} alt="Çekim" className="rounded-2xl aspect-square object-cover mt-8 neon-border" />
            <img src={IMAGES.izmirCoast} alt="İzmir" className="rounded-2xl aspect-square object-cover neon-border" />
            <img src={IMAGES.drone} alt="Drone" className="rounded-2xl aspect-square object-cover mt-8 neon-border" />
          </Reveal>
        </div>
      </section>

      {/* Ektiren partnership */}
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div data-testid="about-ektiren-badge" className="neon-border rounded-3xl glass p-8 sm:p-10 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
            <img src={ektirenLogo} alt="Ektiren Project" className="h-14 w-auto object-contain" />
            <div className="flex-1">
              <p className="font-mono text-xs uppercase tracking-widest text-cobalt-300">Dijital Altyapı Partneri</p>
              <h3 className="mt-1 font-display text-2xl font-bold">Bu site <span className="text-gradient">Ektiren Project</span> tarafından geliştirildi.</h3>
            </div>
            <a href={waLink(EKTIREN.phoneRaw, "Merhaba Ektiren Project")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-cobalt to-neon-purple text-white font-semibold">
              <MessageCircle className="w-4 h-4" /> {EKTIREN.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
